import { useTranslation } from 'react-i18next';
import { Alert } from '@/common/components/Alert/Alert';
import { Translate } from '@/common/components/Translate/Translate';
import { LanguageType } from '@/common/types/general';
import { INTL_MONTH_DAY_FORMAT, intlFormat } from '@/common/utils/date';

export type TPolicyActivationAlertProps = {
  startDate: string;
  upgradeEnded?: boolean;
};

export function PolicyActivationAlert({
  startDate,
  upgradeEnded,
}: TPolicyActivationAlertProps) {
  const { i18n } = useTranslation();
  return (
    <Alert type="warning">
      <Translate
        i18nKey={
          upgradeEnded
            ? 'dashboard.insurance_detail.activation_warning.upgraded'
            : 'dashboard.insurance_detail.activation_warning.default'
        }
        values={{
          date: intlFormat(startDate, INTL_MONTH_DAY_FORMAT, {
            language: i18n.language as LanguageType,
          }),
        }}
      />
    </Alert>
  );
}
